import { getRegionsArray } from "../api/APIUtilities";

import RankingsGroupWidget from "./RankingsGroupWidget";

export default function RankingsWidgetRegional(props) {
  const { rankingGroup, armyId, leagueId, regionId, embed, ...rest } = props;
  const regions = props?.regions?.length ? props?.regions : getRegionsArray();

  return (
    <>
      <RankingsGroupWidget
        league={rankingGroup}
        leagueId={leagueId || rankingGroup.id}
        regionId={regionId}
        regions={regions}
        embed={embed}
        {...rest}
      />
    </>
  );
}
